// extracted by mini-css-extract-plugin
export default {"input":"O7-z","button":"P7-z","selected":"Q7-z","unavailable":"R7-z","oos":"S7-z","image":"T7-z","paperCutDisabledOverlay":"U7-z"};